import * as React from 'react';
var context = /*#__PURE__*/React.createContext(null);
context.displayName = 'CardHeaderContext';
export default context;